import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { EventService } from "../../../services/event.service";
import { PageTitleService } from "../../../services/page-title.service";
import { User } from "../../../app/app.interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs/Subscription";


@Component({
  selector: 'header-bar-mobile',
  templateUrl: 'header-bar-mobile.html'
})
export class HeaderBarMobile implements OnInit, OnDestroy, OnChanges {
	private mobileSidebarOpen: boolean = false;

	@Input() title: string = null;
	@Input() titleContext: any = null;
	@Input() template:string = 'back';
	
	private _mobileTitle: string = '';
	
	private subscriptions: Subscription[] = [];

  constructor(public authService: AuthService,
              public eventService: EventService,
              public translate: TranslateService) {

		
  }
  
  ngOnDestroy(): void {
    for(let subscription of this.subscriptions){
      subscription.unsubscribe();
    }
  }

  
  ngOnChanges(changes: SimpleChanges): void {
    this.setTitle();
  }
  
  ngOnInit(): void {
    this.setTitle();
    
    this.subscriptions.push(
      this.eventService.mobileSidebarToggled.subscribe((active)=> {
        this.mobileSidebarOpen = active;		 
      })
    )
    
  }
  
  private setTitle(){
    if(this.title) {
      this._mobileTitle = this.translate.instant('PAGE_TITLES.'+this.title+'.mobile', this.titleContext);
    }
    else {
      this._mobileTitle = 'CAS';
    }
    
  }
  
}



// WEBPACK FOOTER //
// ./src/partials/header/header-bar-mobile/header-bar-mobile.ts